import { render, staticRenderFns } from "./BusinessTransactionForm.vue?vue&type=template&id=01fbe538&scoped=true"
import script from "./BusinessTransactionForm.vue?vue&type=script&lang=js"
export * from "./BusinessTransactionForm.vue?vue&type=script&lang=js"
import style0 from "./BusinessTransactionForm.vue?vue&type=style&index=0&id=01fbe538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbe538",
  null
  
)

export default component.exports